/**
 * Get all URL parameters
 * https://tree.taiga.io/project/eventhubhq-eventhubclient/issue/760
 * @returns {Object}
 */
export default function GetAllUtmUrlParams() {
  const url = window.location.search;
  const urlParams = new URLSearchParams(url);
  let params = {};

  // get all params if start with utm_
  for (const [key, value] of urlParams) {
    if (key.toLowerCase().startsWith("utm_")) {
      params[key] = value;
    }
  }

  return Object.keys(params).length ? params : null;
}
